import { Component } from 'react';

import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import {
  withButtonAlignment,
  withRtlSupport,
} from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ChevronDownArrow from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-down';
import ChevronUpArrow from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-up';
import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';
import classNames from 'classnames';

import BrowseListCard from '../BrowseListCard';
import constants, { DEFAULT_STRINGS } from '../constants';
import withStrings from '../withStrings';

import ExploreButton from './ExploreButton';

import type { BrowseListProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './BrowseList.module.scss';

type BrowseListState = {
  isExpanded: boolean;
};

const {
  STRINGS: { SEE_FEWER_DESTINATIONS, SEE_MORE_DESTINATIONS },
} = constants;

const ChevronDown = withButtonAlignment(withRtlSupport(ChevronDownArrow));
const ChevronUp = withButtonAlignment(withRtlSupport(ChevronUpArrow));

class BrowseList extends Component<BrowseListProps, BrowseListState> {
  constructor(props: BrowseListProps) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  expandList() {
    this.setState((prevState: { isExpanded: boolean }) => ({
      isExpanded: !prevState.isExpanded,
    }));
  }

  render() {
    const {
      destinations = [],
      enableLazyLoading = true,
      numberOfDestinations,
      query,
      shouldNotRedirectToExplore,
      strings = DEFAULT_STRINGS,
    } = this.props;

    if (!destinations.length) {
      return null;
    }

    const { isExpanded } = this.state;
    const destinationsLimit = shouldNotRedirectToExplore
      ? numberOfDestinations / 2
      : numberOfDestinations;
    const visibleDestinationsLimit =
      isExpanded && shouldNotRedirectToExplore
        ? numberOfDestinations
        : destinationsLimit;
    const visibleDestinationsAmount =
      destinations.length > visibleDestinationsLimit
        ? visibleDestinationsLimit
        : destinations.length;
    const places = destinations.slice(0, visibleDestinationsAmount);

    return (
      <>
        <div className={STYLES.BrowseList}>
          {places.map((destination, index) => (
            <div
              key={destination.destinationId}
              className={classNames(STYLES.BrowseList__column)}
            >
              <BrowseListCard
                enableLazyLoading={enableLazyLoading}
                place={destination}
                position={index + 1}
                query={query}
              />
            </div>
          ))}
        </div>
        <div className={STYLES.BrowseList__exploreButtonContainer}>
          <div className={STYLES.ExploreButton}>
            {shouldNotRedirectToExplore ? (
              <BpkButton
                onClick={() => this.expandList()}
                type={BUTTON_TYPES.link}
                implicit
              >
                <BpkText className={STYLES.ExploreButton__text}>
                  {isExpanded
                    ? strings[SEE_FEWER_DESTINATIONS]
                    : strings[SEE_MORE_DESTINATIONS]}
                </BpkText>
                {isExpanded ? <ChevronUp /> : <ChevronDown />}
              </BpkButton>
            ) : (
              <ExploreButton query={query} />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withStrings(BrowseList);
